import { Tooltip } from '@mui/material'
import { Button } from 'components'
import CircularProgressWithLabel from 'components/CircularProgressWithLabel'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Colors from 'utils/Colors'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import history from 'utils/history'

import styles from './styles'

const getColor = (daysToEnd) => {
  if (daysToEnd >= 45) {
    return Colors.green
  }
  if (daysToEnd >= 30) {
    return Colors.googleYellow
  }
  if (daysToEnd >= 15) {
    return Colors.orange
  }
  return Colors.red
}

const FormStats = (props) => {
  const classes = styles()
  const {
    filled,
    pendingNumber,
    questionsNumber,
    creationDate,
    expiresAt,
    finishedAt,
  } = props

  const [width, setWidth] = useState(window.innerWidth)

  const progressSize = width > 600 ? 150 : 100

  const percentage = ((questionsNumber - pendingNumber) / questionsNumber) * 100

  const endDate = moment(expiresAt, 'DD/MM/YYYY')
  const currentDiff = endDate.diff(moment(), 'days')

  const handleShowForm = () => {
    const url = filled
      ? ROUTE_CONSTANTS.DUE_DILIGENCE_RESUME
      : ROUTE_CONSTANTS.DUE_DILIGENCE
    history.push(url)
    history.go()
  }
  
  useEffect(() => {
    const handleWindowResize = () => {
      setWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <h2>Status do formulário</h2>
        <span
          className={classes.status}
          style={{
            backgroundColor: filled ? Colors.green : Colors.googleYellow,
          }}
        >
          {filled
            ? 'Completo'
            : pendingNumber === 0
            ? 'Envio Pendente'
            : 'Preenchimento Incompleto'}
        </span>
      </header>
      <div className={classes.infoContainer}>
        <div className={classes.dates}>
          <h3>Prazos</h3>
          <p>
            <span>Data de início: </span>
            {creationDate}
          </p>
          <p>
            <span>Data final: </span>
            {expiresAt}
          </p>
          {!filled ? (
            <p>
              <span>Tempo restante: </span>
              <span
                className={classes.status}
                style={{ backgroundColor: getColor(currentDiff) }}
              >
                <span>{String(currentDiff)} dias</span>
              </span>
            </p>
          ) : (
            <p>
              <span>Finalizado em: </span>
              {finishedAt}
            </p>
          )}
        </div>
        <div className={classes.progress}>
          <CircularProgressWithLabel
            value={percentage}
            legend="Progresso"
            size={progressSize}
          />
        </div>
      </div>
      <div className={classes.buttonsContainer}>
        <Tooltip
          title={
            filled
              ? 'Visualizar as respostas do formulario preenchido'
              : 'Iniciar ou continuar o preenchimento do formulário'
          }
        >
          <span>
            <Button onClick={handleShowForm}>
              {filled ? 'Visualizar respostas' : 'Preencher formulário'}
            </Button>
          </span>
        </Tooltip>
      </div>
    </div>
  )
}

export default FormStats
